export const employee = {
    labels: {
        role: "Position",
        sector: "Sector",
        registration_number: "Registration Number",
        start_date: "Start Link",
        end_date: "End Link",
        ges_name: "GES Name",
        ges_status: "GES Status",
        ges_description: "GES Description",
    },
    modal: {
        titles: {
        },
        messages: {
        },
    },
    texts: {},
};
